import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Row,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const ImporterModalConnect = ({
  importer,
  relink,
  handleRedirectToAuthUrl,
}) => {
  const intl = useIntl();

  return (
    <Row className="modal-import-connect">
      <Col className="center">
        {relink ? (
          <p>
            {intl.formatMessage({
              defaultMessage: `Please try linking your account again.
                Make sure to select and grant all permissions when connecting (<link>see how</link>).`,
            }, {
              link: str => <a href="https://help.stockpress.co/en/articles/12620682-my-google-drive-connection-keeps-failing" target="_blank" rel="noreferrer">{str}</a>,
            })}
          </p>
        ) : (
          <>
            <h4>{intl.formatMessage({ defaultMessage: 'Connect your {name} account with Stockpress' }, {
              name: importer.name,
            })}
            </h4>
            <p>
              {intl.formatMessage({ defaultMessage: 'Log in to grant access to {name} and import your files' }, {
                name: importer.name,
              })}
            </p>
          </>
        )}
        <p>
          {importer.button_image_url ? (
            <a
              href="#connect"
              className="connect-button"
              onClick={handleRedirectToAuthUrl}
            >
              <img src={importer.button_image_url} alt="" />
            </a>
          ) : (
            <Button
              size="lg"
              onClick={handleRedirectToAuthUrl}
            >
              {intl.formatMessage({ defaultMessage: 'Connect to {name}' }, { name: importer.name })}
            </Button>
          )}
        </p>
      </Col>
    </Row>
  );
};

ImporterModalConnect.propTypes = {
  importer: PropTypes.object.isRequired,
  relink: PropTypes.bool,
  handleRedirectToAuthUrl: PropTypes.func.isRequired,
};

ImporterModalConnect.defaultProps = {
  relink: false,
};

export default ImporterModalConnect;
